<kw-wrapper class="blog-wrapper" kwBlogSizer>
        <div class="layout-layer">
            <kw-grid-cell-wrapper  class="grid-cell-container with-border" [ngClass]="cell?.classes" [attr.cell-id]="cell.cellId" *ngFor="let cell of gridCells">
                <ng-container [ngSwitch]="cell?.contentEnum">
                    <ng-container *ngSwitchCase="'BLOG_HEADER'">
                        <kw-blog-header-renderer [blogHeader]="cell"></kw-blog-header-renderer>
                        
                        <!-- <div class="blog-meta-data">
                            <div class="author-data">
                                <kw-content-element-renderer [contentElement]="authorContent" [preview]="preview" (updatedContent)="onUpdateContent($event)"></kw-content-element-renderer>
                            </div>
                            <div class="date-data">
                                <kw-content-element-renderer [contentElement]="dateContent" [preview]="preview" (updatedContent)="onUpdateContent($event)"></kw-content-element-renderer>
                            </div>
                        </div> -->
                    </ng-container>
                    <ng-container *ngSwitchCase="'BLOG_SUMMARY'">
                        <div *ngFor="let contentElement of cell?.contentElements" [ngClass]="contentElement.containerClasses">
                            <kw-content-element-renderer [contentElement]="contentElement" [preview]="preview" (updatedContent)="onUpdateContent($event)"></kw-content-element-renderer>
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Blog Share'">
                        <div class="socials">
                            <div class="social"><i class="fas fa-share-alt fa-2x"></i></div>
                            <div class="social">
                                <i class="fab fa-twitter fa-2x" aria-hidden="true"></i>
                            </div>
                            <div class="social">
                                <i _ngcontent-qeb-c317="" class="fab fa-facebook fa-2x"></i>
                            </div>
                            <div class="social">
                                <i class="fab fa-whatsapp fa-2x" aria-hidden="true"></i>
                            </div>
                            <div class="social">
                                <i class="fab fa-snapchat fa-2x"></i>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'NAV_LIST'">
                        <kw-blog-nav-renderer [cell]="cell"></kw-blog-nav-renderer>
                    </ng-container>
                    <ng-container *ngSwitchCase="'BLOG_MAIN'">
                        <div *ngFor="let contentElement of cell?.contentElements" [ngClass]="contentElement.containerClasses">
                            <kw-content-element-renderer [contentElement]="contentElement" [preview]="preview" (updatedContent)="onUpdateContent($event)"></kw-content-element-renderer>
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'BLOG_COMMENTS'">
                        <div *ngFor="let contentElement of cell?.contentElements" [ngClass]="contentElement.containerClasses">
                            <kw-content-element-renderer [contentElement]="contentElement" [preview]="preview" (updatedContent)="onUpdateContent($event)"></kw-content-element-renderer>
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <div *ngFor="let contentElement of cell?.contentElements" [ngClass]="contentElement.containerClasses">
                            <kw-content-element-renderer [contentElement]="contentElement" [preview]="preview" (updatedContent)="onUpdateContent($event)"></kw-content-element-renderer>
                        </div>
                    </ng-container>
                </ng-container>
                
            </kw-grid-cell-wrapper>
        </div>
</kw-wrapper>


